import CountUp from 'react-countup'
import React, { useEffect, useState, useRef } from "react"
import ReactDOM from 'react-dom'

export default function WidgetExample(props) {
  const [total, setTotal] = useState(99)
  const sceneRef = useRef(null)
  const [animating, setAnimating] = useState(false)

  // every 1.8s, trigger animate + bump total
  useEffect(() => {
    const iv = setInterval(() => {
      setAnimating(true);
      setTotal(t => t + 99);
      setTimeout(() => setAnimating(false), 300);
    }, 1800);
    return () => clearInterval(iv);
  }, []);

  useEffect(() => {
    const order = [
      'wallets-3d-wrapper--1', // front
      'wallets-3d-wrapper--2', // middle
      'wallets-3d-wrapper--3'  // back
    ];
    const scene = sceneRef.current;
    if (!scene) return;

    const handleClick = e => {
      const card = e.target.closest('.wallets-3d-wallet');
      if (!card) return;

      // which wrapper (by class) was clicked?
      const wrapper = card.parentElement;
      const oldClass = order.find(c => wrapper.classList.contains(c));
      const clickedIndex = order.indexOf(oldClass);
      if (clickedIndex < 0) return;

      // 1) build an array of the THREE wrapper elements in [front, mid, back] order:
      const posToElem = order.map(c => scene.querySelector(`.${c}`));

      // 2) rotate that elements-array so the clickedIndex lands in front:
      const newPosToElem = [
        ...posToElem.slice(clickedIndex),
        ...posToElem.slice(0, clickedIndex)
      ];

      // 3) give them back their “slot” classes in proper order:
      newPosToElem.forEach((el, idx) => {
        el.classList.remove(...order);
        el.classList.add(order[idx]);
      });
    };

    scene.addEventListener('click', handleClick);
    return () => scene.removeEventListener('click', handleClick);
  }, []);

  return (
    <div className="position-relative wallets-3d-scene" ref={sceneRef}>
      <div className="wallets-3d-wrapper wallets-3d-wrapper--3">
        <div className="wallets-3d-wallet d-flex flex-column phantom">
          <div className="wallets-3d-wallet-logo"></div>

          <div className="px-3 ">
            <div className="pt-3 ps-3">
              <div className="text-left font-size-xs ps-4 opacity-50 line-height-extra-small">@toly</div>
              <div className="text-left font-size-s ps-4 line-height-extra-small">Account 1</div>
            </div>
            <div className="pt-3 font-size-xl text-center">
              <div className="font-size-xl fw-medium">$<CountUp start={total-99} key={total} end={total} duration={1.6} separator="," /></div>
            </div>

            <div className="pt-2">
              <div className="row pt-4 px-3 py-2 fw-medium font-size-s">
                Recent Activity
              </div>
            </div>
          </div>

          <div className={`wallets-3d-row-wrapper ${animating ? 'animating' : ''} d-flex flex-column flex-grow-1 overflow-hidden px-3`} style={{ height: "230px" }}>
            {Array.from({ length: 6 }).map((_, idx) => (
              <div
                key={idx}
                className="wallets-3d-row p-2 font-size-xs align-items-center"
                style={{
                  '--idx': idx
                }}
              >
                <div className="row">
                  <div className="col-2 text-end pe-0 ps-3">
                    <div className="wallets-3d-wallet-token-logo ms-1 usdc"/>
                  </div>
                  <div className="col-6 ps-2">Payment</div>
                  <div className="col-4">
                    <div className="row">+ 99 USDC</div>
                    <div className="row font-size-xs opacity-50">
                      + 99.00 USD
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="wallets-3d-wallet-shadow-wrapper">
          <div className="wallets-3d-wallet-shadow"></div>
        </div>
      </div>
      <div className="wallets-3d-wrapper wallets-3d-wrapper--2">

        <div className="wallets-3d-wallet metamask">
          <div className="wallets-3d-wallet-logo"></div>
          
          <div className="px-3 ">
            <div className="pt-3">
              <div className="text-center line-height-extra-small">Account 1</div>
            </div>
            <div>
              <div className="text-center opacity-50 font-size-s">0xd8dA6...96045</div>
            </div>
            <div className="pt-3 font-size-l">
              <div className="font-size-xl fw-medium">$<CountUp start={total-99} key={total} end={total} duration={1.6} separator="," /> USD</div>
            </div>

            <div className="row pt-4 pb-2">
              <div className="col col-4 border-bottom border-black px-3 py-2 fw-medium font-size-xs">
                Activity
              </div>
            </div>
          </div>

          <div className={`wallets-3d-row-wrapper ${animating ? 'animating' : ''} d-flex flex-column flex-grow-1 overflow-hidden px-3`} style={{ height: "230px" }}>
            {Array.from({ length: 6 }).map((_, idx) => (
              <div
                key={idx}
                className="wallets-3d-row p-2 font-size-xs align-items-center"
                style={{
                  '--idx': idx
                }}
              >
                <div className="row">
                  <div className="col-2 text-end pe-0 ps-3">
                    <div className="wallets-3d-wallet-token-logo ms-1 usdc"/>
                  </div>
                  <div className="col-6 ps-2">Payment</div>
                  <div className="col-4">
                    <div className="row">+ 99 USDC</div>
                    <div className="row font-size-xs opacity-50">
                      + 99.00 USD
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
         
        </div>
        <div className="wallets-3d-wallet-shadow-wrapper">
          <div className="wallets-3d-wallet-shadow"></div>
        </div>
      </div>
      <div className="wallets-3d-wrapper wallets-3d-wrapper--1">
        <div className="wallets-3d-wallet d-flex flex-column coinbase">
          <div className="wallets-3d-wallet-logo"></div>

          <div className="px-3 ">
            <div className="pt-3 ps-3">
              <div className="text-left font-size-s pt-2 ps-4">Address 1</div>
            </div>
            <div className="pt-3 font-size-l">
              <div className="font-size-m fw-medium">$<CountUp start={total-99} key={total} end={total} duration={1.6} separator="," /></div>
            </div>

            <div className="row pt-5 px-3 py-2 fw-medium font-size-s">
              Transactions
            </div>
          </div>

          <div className={`wallets-3d-row-wrapper ${animating ? 'animating' : ''} d-flex flex-column flex-grow-1 overflow-hidden px-3`} style={{ height: "230px" }}>
            {Array.from({ length: 6 }).map((_, idx) => (
              <div
                key={idx}
                className="wallets-3d-row p-2 font-size-xs align-items-center"
                style={{
                  '--idx': idx
                }}
              >
                <div className="row">
                  <div className="col-2 text-end pe-0 ps-3">
                    <div className="wallets-3d-wallet-token-logo ms-1 usdc"/>
                  </div>
                  <div className="col-6 ps-2">Payment</div>
                  <div className="col-4">
                    <div className="row">+ 99 USDC</div>
                    <div className="row font-size-xs opacity-50">
                      + 99.00 USD
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

        </div>
        <div className="wallets-3d-wallet-shadow-wrapper">
          <div className="wallets-3d-wallet-shadow"></div>
        </div>
      </div>
    </div>
  )
}
